import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const WidgetIframeIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" d="M13,20 L20,20 L20,4 L4,4 L4,11 L11,11 C12.1045695,11 13,11.8954305 13,13 L13,20 Z M11,20 L11,13 L4,13 L4,20 L11,20 Z M4,2 L20,2 C21.1045695,2 22,2.8954305 22,4 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,4 C2,2.8954305 2.8954305,2 4,2 Z"/>
  </SvgIcon>;
};
